




















































































import Vue, { PropType } from "vue";
import { FooterSettings } from "@/models";

export default Vue.extend({
  name: "Footer",
  props: {
    settings: Object as PropType<FooterSettings>
  }
});
